import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddPackingModal: false,
  clearSelection: false,
  showDeleteModal: false,
  selectedItem: "",
  isEdit: false,
  itemData: [],
};

const packingSlice = createSlice({
  name: "packing",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = packingSlice.actions;

export default packingSlice.reducer;
